'use client';
import { useProGlove } from '@/components/proglove/ProgloveProvider';
import { type ProGloveScreen } from '@/components/proglove/display/screens';
import { useEffect } from 'react';

/**
 * Shows a screen on the paired glove while the calling component is mounted.
 * `null` shows nothing (e.g. while the data for the screen is not loaded yet).
 *
 * Sends again only when the content changes: an equal screen rebuilt on a
 * re-render is not re-sent. Device changes (pairing, reload) are handled by
 * the provider, which re-sends the current screen itself.
 */
export default function useProGloveScreen(screen: ProGloveScreen | null): void {
  const { showScreen } = useProGlove();
  const screenKey = screen === null ? null : JSON.stringify(screen);

  useEffect(() => {
    if (screenKey !== null) {
      // rebuilt from the key, so the effect depends on content only
      const keyedScreen: ProGloveScreen = JSON.parse(screenKey);
      showScreen(keyedScreen);
    }
  }, [screenKey, showScreen]);
}
